module.exports = __webpack_public_path__ + "pc/img/main_work_img4.be8c1646.jpg";